import AppWrapper from './AppWrapper'
import React, { useEffect } from 'react'
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { appUrls } from '../../utils/urls/appUrls'
import '../../assets/css/layoutStyles.css'
import '../../assets/css/certifcateStyles.css'
import { clearAll, clearResponseMsg, clearOnReload, logoutBankUser } from '../../config/redux/slice/bankUserSlice'
import { logoutAppUser, onGetCurrencies, setActiveSidebar } from '../../config/redux/slice/appSlice';
import { getRequest } from '../../helpers/request';
import { appApi } from '../../utils/endpoints/appApi';
import { handleOnPageLoad, handleOverlayClick } from '../../helpers/sideBarToggle';
import { logoutUser } from '../../config/redux/slice/authSlice';
import { logoutNotapUser } from '../../config/redux/slice/notapUserSlice';
import { logoutTransfereeUser } from '../../config/redux/slice/transfereeUserSlice';

export default function BankWrapper({children, pageTitle}) {
    const dispatch = useDispatch()
  const navigate = useNavigate()
  const {
        bankUserErrorMsg,
        bankUserSuccessMsg,
    } = useSelector((state) => state.bankUser)

  const {
        token,
        userData: {isProfileComplete, user_role}
    } = useSelector((state) => state.authData)

    const {isActive} = useSelector((state) => state.app)

    useEffect(()=>{
      dispatch(clearOnReload())
    dispatch(clearAll())
    }, [])

    const showToastMessage = (msg, isError) => {
      if(isError){
        toast.error(msg, {
            position: toast.POSITION.TOP_RIGHT
        });
      } else{
        toast.success(msg, {
            position: toast.POSITION.TOP_RIGHT
        });
      }
        
    };


    useEffect(()=>{
    if(bankUserSuccessMsg){
        let msg;
        if(Array.isArray(bankUserSuccessMsg)){
          msg = bankUserSuccessMsg[0].toLowerCase().charAt(0).toUpperCase() + bankUserSuccessMsg[0].slice(1)
        } else{
          msg = bankUserSuccessMsg.toLowerCase().charAt(0).toUpperCase() + bankUserSuccessMsg.slice(1)
        }

        dispatch(clearResponseMsg())

        showToastMessage(msg, false)
        
    }

    if(bankUserErrorMsg){
      let err
      if(Array.isArray(bankUserErrorMsg)){
        err = bankUserErrorMsg[0].toLowerCase().charAt(0).toUpperCase()+bankUserErrorMsg[0].slice(1)
      }
      else{
        err = bankUserErrorMsg.toLowerCase().charAt(0).toUpperCase()+bankUserErrorMsg.slice(1)
      }
        dispatch(clearResponseMsg())
        if(err == 'Invalid token'){
          dispatch(logoutUser())
          dispatch(logoutBankUser())
          dispatch(logoutAppUser())
          dispatch(logoutNotapUser())
          dispatch(logoutTransfereeUser())
          err = null
        }else{
          showToastMessage(err, true)
        }

        // showToastMessage(err, true)
    }
    }, [bankUserSuccessMsg, bankUserErrorMsg])

  return (
    <AppWrapper pageTitle={pageTitle}>
      <>
      {children}
      </>
    </AppWrapper>
  )
}
